import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Overline, Reveal } from "./Reveal";

const cases = [
  { tag: "GenAI", title: "Knowledge assistant over internal documents", body: "Staff ask questions in plain language and get cited answers from policies, manuals and tickets.", img: "/img/blocks.jpg", color: "text-violet" },
  { tag: "Data + AI", title: "Forecasting on a modern data platform", body: "Unified pipelines feed demand and revenue forecasts straight into the dashboards teams already use.", img: "/img/fans.jpg", color: "text-emerald" },
  { tag: "Automation", title: "Document intake and triage, automated", body: "Emails, forms and PDFs are read, classified and routed to the right system without manual re-keying.", img: "/img/hero.jpg", color: "text-coral" },
];

const CaseCard = ({ c, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <Reveal delay={i * 0.1}>
      <article ref={ref} data-testid={`case-card-${i + 1}`} className="group">
        <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-ink [clip-path:inset(0_round_24px)]">
          <motion.img style={{ y }} src={c.img} alt={c.title} className="absolute inset-0 h-[124%] w-full -translate-y-[12%] object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
          <span className="absolute left-4 top-4 rounded-full bg-[#FBF9F5] px-3 py-1 font-mono text-xs uppercase tracking-[0.15em] text-ink">{c.tag}</span>
        </div>
        <p className={`mt-6 font-mono text-xs uppercase tracking-[0.2em] ${c.color}`}>Use case 0{i + 1}</p>
        <h3 className="mt-2 font-display text-3xl leading-tight text-ink">{c.title}</h3>
        <p className="mt-3 text-base leading-relaxed text-ink/75">{c.body}</p>
      </article>
    </Reveal>
  );
};

export const Cases = () => (
  <section id="cases" data-testid="case-studies-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-6 md:py-36 lg:px-8">
    <Overline color="bg-violet">03 — Use cases</Overline>
    <h2 className="mb-16 max-w-4xl font-display text-5xl leading-[1] tracking-tight text-ink sm:text-6xl lg:text-7xl">
      <MaskLines inView lines={["What we typically", <em className="text-coral">put into production.</em>]} />
    </h2>
    <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
      {cases.map((c, i) => (
        <div key={c.title} className={i === 1 ? "md:mt-24" : ""}><CaseCard c={c} i={i} /></div>
      ))}
    </div>
  </section>
);
